class FooterSearch {
	constructor( elem ){
		this.elem = elem;

		if (this.elem) {
			this.input = this.elem.find('input')
			this.bindEvents()
		}
	}

	bindEvents() {
		this.input.on('focus', () => {
			this.elem.addClass('focused')
		})
		
		this.input.on('blur', () => {
			this.elem.removeClass('focused')
		})
	}
}

export default FooterSearch;